module.exports = __webpack_public_path__ + "img/product-program-ykp-icon3.5004dd99.png";